module.exports = __webpack_public_path__ + "img/slip_sample_1.ced3cc50.jpg";